/**
 * 主观题答案 (填空/简答)
 */
import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import { Col, Row } from "antd";
import classNames from "classnames";
import useDeviceType from "Utils/useDeviceType";
import { TopicsItem } from "../../../../../../../API/exercise";

interface StuAnswerSubProps {
    data: TopicsItem;
    stuDoFlg: string;
    viewPaper?: string; //主观题在活动结束的时候老师未批也需要显示x号
}

export default function StuAnswerSub({
    data,
    stuDoFlg,
    viewPaper
}: StuAnswerSubProps) {
    const { isMobile } = useDeviceType();
    const labelSpan = isMobile ? 24 : 3;
    const contentSpan = isMobile ? 24 : 18;

    const [objectList, setObjectList] = useState<any[]>();
    useEffect(() => {
        if (data.queTypeId == "5" && data.stuAns) {
            let list = [];
            let answerObj = JSON.parse(data.stuAns);
            for (let key in answerObj) {
                list.push(answerObj[key]);
            }
            setObjectList(list);
        }
    }, [data]);

    return (
        <div className={style.root}>
            <div className={style.body}>
                {/*主观题提交了，并且作答了而且正确，显示正确答案和正确图标（主观题对错图标，未批不显示，批了再显示）*/}
                {data.queTypeId == "4" &&
                    stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "1" && (
                        <>
                            <div className={style.row}>
                                <div
                                    className={classNames(style.label, {
                                        [style.rowRight]:
                                            data.teacherMark === "1"
                                    })}>
                                    我的答案
                                </div>
                            </div>
                            <div className={style.row}>
                                <div
                                    className={classNames(
                                        style.answerSpan,
                                        style.stuAnswer
                                    )}
                                    dangerouslySetInnerHTML={{
                                        __html: data.stuAns
                                    }}
                                />
                            </div>
                        </>
                    )}

                {data.queTypeId == "4" &&
                    stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "0" && (
                        <>
                            <div className={style.row}>
                                <div
                                    className={classNames(style.label, {
                                        [style.rowWrong]:
                                            data.teacherMark === "1" ||
                                            viewPaper === "1"
                                    })}>
                                    我的答案
                                </div>
                            </div>
                            <div className={style.row}>
                                <div
                                    className={classNames(
                                        style.answerSpan,
                                        style.stuAnswer
                                    )}
                                    dangerouslySetInnerHTML={{
                                        __html: data.stuAns
                                    }}
                                />
                            </div>
                        </>
                    )}

                {/*填空题提交了，并且作答了而且正确，显示正确答案和正确图标*/}
                {data.queTypeId == "5" &&
                    stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "1" && (
                        <>
                            <div className={style.row}>
                                <div
                                    className={classNames(
                                        style.label,
                                        style.rowRight
                                    )}>
                                    我的答案
                                </div>
                            </div>
                            <div className={style.row}>
                                {objectList &&
                                    data.stuAns &&
                                    objectList.map((item, index) => {
                                        return (
                                            <div className={style.stuAnswer}>
                                                填空{index + 1}:{item}
                                            </div>
                                        );
                                    })}
                            </div>
                        </>
                    )}

                {data.queTypeId == "5" &&
                    stuDoFlg === "1" &&
                    data.stuFinishTopic === "1" &&
                    data.stuIsRight === "0" && (
                        <>
                            <div className={style.row}>
                                <div
                                    className={classNames(
                                        style.label,
                                        style.rowWrong
                                    )}>
                                    我的答案
                                </div>
                            </div>
                            <div className={style.row}>
                                {objectList &&
                                    data.stuAns &&
                                    objectList.map((item, index) => {
                                        return (
                                            <div className={style.stuAnswer}>
                                                填空{index + 1}:{item}
                                            </div>
                                        );
                                    })}
                            </div>
                        </>
                    )}

                {/*主关和填空题，学生未提交答案状态为未作答，学生提交过如果这题没答也算未作答给出对错图标*/}
                {stuDoFlg === "0" && (
                    <>
                        <div className={style.row}>
                            <div className={classNames(style.label)}>
                                我的答案
                            </div>
                        </div>
                        <div className={style.row}>
                            <div
                                className={classNames(style.span, style.empty)}>
                                未作答
                            </div>
                        </div>
                    </>
                )}
                {stuDoFlg === "1" && data.stuFinishTopic === "0" && (
                    <>
                        <div className={style.row}>
                            <div
                                className={classNames(
                                    style.label,
                                    style.rowWrong
                                )}>
                                我的答案
                            </div>
                        </div>
                        <div className={style.row}>
                            <div
                                className={classNames(style.span, style.empty)}>
                                未作答
                            </div>
                        </div>
                    </>
                )}

                <div className={style.score}>
                    本题得分
                    {/*stuDoFlg没提交分数显示--,提交了分数显示数值或0*/}
                    {stuDoFlg === "0" && (
                        <span
                            className={classNames(
                                style.span,
                                style.scoreSpanMargin
                            )}>
                            <em className={style.em}>--</em> 分
                        </span>
                    )}
                    {stuDoFlg === "1" && data.queTypeId == "5" && (
                        <span
                            className={classNames(
                                style.span,
                                style.scoreSpanMargin
                            )}>
                            <em className={style.em}>{data.stuScore || 0}</em>{" "}
                            分
                        </span>
                    )}
                    {/*主观题特殊，需要判断老师批没批，没批显示未批*/}
                    {stuDoFlg === "1" && data.queTypeId == "4" && (
                        <span
                            className={classNames(
                                style.span,
                                style.scoreSpanMargin
                            )}>
                            {data.teacherMark === "1" && (
                                <span>
                                    <em className={style.em}>
                                        {data.stuScore || 0}
                                    </em>
                                    分
                                </span>
                            )}
                            {data.teacherMark === "0" && (
                                <em className={style.em}>未批</em>
                            )}
                        </span>
                    )}
                    <span
                        className={classNames(
                            style.totalScore,
                            style.scoreSpanMargin
                        )}>
                        （本题{data.score}分）
                    </span>
                </div>

                {
                    //主关题显示评语（未提交显示--，提交了显示暂无评语或评语）
                    data.queTypeId == "4" && (
                        <Row type="flex" style={{ marginTop: 20 }}>
                            <Col span={labelSpan}>
                                <div className={style.label}>本题评语</div>
                            </Col>
                            {stuDoFlg === "0" && (
                                <Col className={style.grey} span={contentSpan}>
                                    --
                                </Col>
                            )}
                            {stuDoFlg === "1" && (
                                <Col className={style.grey} span={contentSpan}>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                data.teacherComment ||
                                                "暂无评语"
                                        }}
                                    />
                                </Col>
                            )}
                        </Row>
                    )
                }
            </div>

            {
                //主关题显示
                data.queTypeId == "4" && (
                    <div className={style.footer}>
                        <div className={style.label}>参考答案</div>
                        <div
                            className={classNames(
                                style.rightAnswer,
                                style.grey
                            )}
                            dangerouslySetInnerHTML={{
                                __html: data.analysis || "无"
                            }}
                        />
                    </div>
                )
            }

            {
                //填空题显示
                data.queTypeId == "5" && (
                    <div className={style.footer}>
                        【正确答案】{" "}
                        <div
                            className={style.footerAnswer}
                            dangerouslySetInnerHTML={{
                                __html: data.rightAnsText || "无"
                            }}
                        />
                    </div>
                )
            }
        </div>
    );
}
